// extracted by mini-css-extract-plugin
export default {"instagramLogo":"Footer_instagramLogo__8jJj2","mainFoot":"Footer_mainFoot__3wo8J","corpInfo":"Footer_corpInfo__wNnWp"};